<div class="expandable-content__wrapper">
	<div
		class="expandable-content"
		[class.expandable-content--border]="enableBorder"
		[class.p-24]="enableBorder"
		[class.expandable-content--flat-t]="flatTopBorder"
		[class.expandable-content--flat-b]="flatBottomBorder"
		[class.expandable-content--full]="toggleValue"
		[class.expandable-content--no-overlay]="contentElement.scrollHeight < boxHeight"
		[ngStyle]="{ 'max-height': boxHeight + 'px' }"
		#contentElement>
		<ng-content></ng-content>
	</div>

	@if (contentElement.scrollHeight >= boxHeight) {
		<a
			href="#"
			class="expandable-content__link baseline"
			[class.expandable-content__link--left]="enableBorder"
			[class.expandable-content__link--center]="!enableBorder"
			(click)="toggleContent(contentElement); $event.preventDefault()"
			>{{ toggleValue ? openedText : closedText }}</a
		>
	}
</div>
